import React, { useEffect, useState } from 'react'
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import NuDate from '../../../../Components/Utils/NuDate';
import CloseIcon from '../../../../Components/Icons/Close';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import { GetAccess } from '../../../../Components/Utils/roles';
import CollectionAndReturnsLayout from '../CollectionAndReturnsLayout';
import { useFormik } from 'formik';
import axiosInstance from '../../../../Services/axiosCommon';
import UseGetDataSearchByProUser from '../../../../Components/Hooks/useFetchDataByPROUser';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';
import ModileFireExtinguister from '../../../Mobile/CollectionAndReturn/FireExtinguister/ModileFireExtinguister';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch'
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import ImportFireSuppression from './ImportFireSuppression';
import MultiFS from './MultiFireSuppression';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';


function FireSuppressionIndex() {
  const { value: status, getData: refstatus } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Status_FireExtinguisher"
  );
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
      });
    
      useEffect(() => {
        const handleResize = () => {
          setScreenSize({
            width: window.innerWidth,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);

  const [open, setOpen] = useState(false);
  const location = useLocation();
  const state = location.state;
    const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );
  const [filter, setFilter] = useState(state?.industry ? true : false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [filterProps, setFilterProps] = useState({
    type:2,
    status:"",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    type:2
   
  });
  const clearFilter = () => {
    setParams({
      ...params,status:"",
    });
    formik.values.type=2;
    formik.values.status="";
    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({ ...params, type: value.type,status:value.status });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        type:2,
        status:"",
      });
    },
  });
  const { data, totalCount,getData, dataLoading } = UseGetDataSearch(
    `/collection-and-returns/listing`,
    params
  );
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("viewMode") || "card"
  );



  const defaultHeader = [
    // {
    //     title: "ID",
    //     width: "5%",
    //     field: "contractId",
    //     textAlign: "center",
    //     rowAlign: "center",
    //   },



      {
        title: "ContractRef No",
        width: "10%",
        isLink: true,
        id: "id",
        link: `/collectionAndreturn/fireSuppression/view/`,
        field: "contractRefNumber",
        textAlign: "center",
        rowAlign: "center",
      },
      {
        title: "Referencer NO",
        width: "20%",
        type: "number",
        field: "refNumber",
        textAlign: "center",
        rowAlign: "center",
        isLink: true,
        link: `/collectionAndreturn/fireSuppression/view/`,
      },
      
  
      // {
      //   title: "CreatedBy ",
      //   width: "10%",
      //   field: "createdBy",
      //   textAlign: "center",
      //   rowAlign: "center",
      // },
      {
        title: "Delivered On",
        width: "20%",
        type: "date",
        field: "deliveredOn",
        textAlign: "center",
        rowAlign: "center",
      },
     
      {
        title: "Collected On ",
        width: "20%",
        type: "date",
        field: "collectedOn",
        textAlign: "center",
        rowAlign: "center",
      },
      {
        title: "Status ",
        width: "20%",
        field: "status",
        textAlign: "center",
        rowAlign: "center",
      },
    
    {
      title: "Action",
      width: "10%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "id",
        removeValue: "id",
        url: `/collection-and-returns/`,
        moduleName: "fireSuppression",
        from: `/collectionAndreturn/fireSuppression/`,
        editLink: `/collectionAndreturn/fireSuppression/edit/`,
        viewLink: `/collectionAndreturn/fireSuppression/view/`,
      },
    },
  ];
  const availableHeaders = [
   
  ];
  useEffect(() => {
    localStorage.setItem("viewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount, viewMode]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };
  const [showExport, setShowExport] = useState(false);
  const [exportValue, setExportValue] = useState({
sNo:"", 
inspectionType :"" ,
FireExtinguisher:"" ,
contractId :"" ,
location :"" ,
inspectionStartDate:"", 
inspectionEndDate :"" ,
status:"",
  });
  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      try {
        const response = await axiosInstance.get(
          `/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`,
          {
            responseType: "blob",
          }
        );

        const pdfBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = `CQ Report ${NuDate({
          value: new Date(),
          format: "DD-MMM-YYYY",
        })}.xlsx`;

        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      }
    },
  });
  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    console.log("sss", value);

    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
    console.log("sss", listofNumbers);
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      console.log("if List", fullList);
      setListofNumbers(fullList);
    } else {
      console.log("else List", fullList);
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        console.log("I", i);
        tempArr.push(i?.id);
      });
    setFullList(tempArr);
  }, [data]);

  const [valueOfSearch,setValuesofSearch] = useState("")
  function searchFunction(e) {

    
    setValuesofSearch(e?.target?.value)
    setParams({ ...params, search: e?.target?.value, page:1 });
    setPage(1)
  }

  
  return (
    <>
<CollectionAndReturnsLayout 
      setOpen={setShowImportModal}
      searchFun={searchFunction}
      setOpenExport={setShowExport}

        getData={getData}
        isCard={true}
        isFilter={filter}
         newfilter={true}
        setFilterOpen={setShowFilterDialog}
        ClearFilter={clearFilter}
        CreateAccess={GetAccess("customers_create")}
        ImportAccess={GetAccess("customers_create")}
        ExportAccess={GetAccess("customers_create")}

            searchValue={valueOfSearch}
        setViewMode={setViewMode}
        neededSearch={true}
        viewMode={viewMode}
        // handleSearch={handleSearch}
        >
              {
  screenSize.width <= "786" ?(<>
  <div className=' w-full h-[calc(100vh-160px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
  <ModileFireExtinguister
  data={data}
  total={totalCount}
  pageIndex={page}
  setPageIndex={setPage}
  dataCount={pageCount}
  setDataCount={setPageCount}

  getData={getData}

  />
  </div>
  </>):(<>
    <div className="w-full h-full ">
      
            <CustomDataTable
            fetcher={getData}
            data={data}
          availableHeaders={availableHeaders}
          defaultHeader={defaultHeader}
          bodyHeight="max-h-[calc(100vh-260px)]"
          height="h-[calc(100vh-160px)]"
          total={totalCount}
          pageIndex={params.page}
          setPageIndex={setPage}
          dataCount={params.per_page}
          setDataCount={setPageCount}
          storageName="FireSuppressionTable"
          editAccess="FireSuppression_edit"
          deteleAccess="FireSuppression_delete"
          dataLoading={dataLoading}
          searchQuery={params?.search != "" ? params?.search : ""}
          hasMultiEdit={true}
          selectOneFunction={selectOneFunction}
          setShowEdit={setShowEdit}
          showEdit={showEdit}
          listofNumbers={listofNumbers}
          selectMultipleFunction={selectMultipleFunction}
          fullList={fullList}
          getById="id"
        />
   
      </div>
      </>)}
      </CollectionAndReturnsLayout>
     
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">

              <DropDownAddMetaData
              label="Status"
              placeholder="Choose"
              Options={status}
              formik={formik}
              name="status"
              width="w-full "
              getFunc={refstatus}
              displayProperty={"Status"}
              propertyName={"Status_FireExtinguisher"}
              FixPosition={false}
              PortalTarget={false}
            />

                <NuDate
                  label="Inspection Date"
                  placeholder="Inspection Date"
                  formik={formik}
                  name="InspectionDate"
                  width="w-full"
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}

      {showEdit && (
        <MultiFS
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportFireSuppression
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}
     {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type =="all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                    <NuDate
                      label="From "
                      placeholder="dd/mm/yyyy"
                      formik={ExportFormik}
                      name="fromDate"
                      width="w-1/2 "
                    />
                    <NuDate
                      label="To "
                      placeholder="dd/mm/yyyy"
                      formik={ExportFormik}
                      name="toDate"
                      width="w-1/2"
                    />

                    <FormikSelectTwo
                      type="text"
                      label="Sales Person"
                      placeholder="Choose"
                      Options={[]}
                      formik={ExportFormik}
                      name="salesPerson"
                      width="w-1/2"
                    />

                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}


export default FireSuppressionIndex;